import React from 'react'
import { Grid } from '@material-ui/core'
import { Field } from '@progress/kendo-react-form'
import { Input } from '@progress/kendo-react-inputs'
import { DatePickerField, DropDownField, ComboBoxField } from '../index'
import { StyledPaper, InnerGrid} from '../styled/FormComponents'
import { useSelector } from 'react-redux'
import { getLanguages } from '../../store/selectors'
import { getMediaTypeOptions, getStatusOptions } from '../../services'

export default ({ spaceBetweenGrids, form }) => {
    const languages = useSelector(getLanguages).filter(entry => !!entry.title)
    const mediaTypes = getMediaTypeOptions()
    const statusOptions = getStatusOptions()

    return <Grid container spacing={spaceBetweenGrids}>
        <InnerGrid item md={2}>
            <StyledPaper>
                <Field name="project.edition" component={Input} label="Auflage"/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={2}>
            <StyledPaper>
                <Field name="project.projectLanguage" component={DropDownField} label="Sprache" data={languages}/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={2}>
            <StyledPaper>
                <Field name="project.mediaType" component={ComboBoxField} label="Werbemittel"
                       data={mediaTypes} allowCustom suggest filterable/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={2}>
            <StyledPaper>
                <Field name="project.status" component={ComboBoxField} label="Nach-/Neudruck"
                       data={statusOptions} allowCustom suggest/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={2}>
            <StyledPaper>
                <DatePickerField name="project.startDate" label="Eingang" form={form}/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={2}>
            <StyledPaper>
                <DatePickerField name="project.endDate" label="Projektabschluss" form={form}/>
            </StyledPaper>
        </InnerGrid>
    </Grid>
}



// WEBPACK FOOTER //
// ./src/components/dialog/ProjectHeaderForm.js